<p-dialog
	header="Risk Resolution"
	[visible]="visible"
	[modal]="true"
	[closable]="!isSaving"
	[closeOnEscape]="!isSaving"
	[dismissableMask]="!isSaving"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '720px', maxWidth: '95vw' }"
	[breakpoints]="{
      '960px': '80vw',
      '640px': '95vw'
   }"
	(visibleChange)="onDialogVisibleChange($event)"
>
	<div class="risk-resolution-modal">
		<div class="resolution-summary">
			<div>
				<strong>Row risk status</strong>
				<span>
					{{ riskResolution?.resolvedRiskCount ?? 0 }} of
					{{ riskResolution?.totalRiskCount ?? 0 }}
					resolved
				</span>
			</div>

			<span
				class="resolution-status"
				[class.resolution-status-resolved]="
               riskResolution?.status === 'RESOLVED'
            "
				[class.resolution-status-partial]="
               riskResolution?.status === 'PARTIALLY_RESOLVED'
            "
			>
				{{
					riskResolution?.status === 'PARTIALLY_RESOLVED'
						? 'Partially Resolved'
						: riskResolution?.status === 'RESOLVED'
							? 'Resolved'
							: 'Unresolved'
				}}
			</span>
		</div>

		<div
			*ngIf="actionOptions.length > 1"
			class="resolution-action-selector"
		>
			<label>Action</label>

			<p-selectButton
				[options]="actionOptions"
				[(ngModel)]="selectedAction"
				optionLabel="label"
				optionValue="value"
				[allowEmpty]="false"
				[disabled]="isSaving"
				(onChange)="onActionChanged()"
			></p-selectButton>
		</div>

		<div
			*ngIf="actionOptions.length === 1"
			class="resolution-action-single"
		>
			<strong>Action</strong>
			<span>{{ actionOptions[0].label }}</span>
		</div>

		<section class="risk-selection">
			<div class="risk-selection-heading">
				<div>
					<h3>Select risks</h3>
					<p>
						Only risks applicable to the selected action can be changed.
					</p>
				</div>

				<span>
					{{ selectedRiskCodes.length }}
					selected
				</span>
			</div>

			<div class="risk-list">
				<label
					*ngFor="
                  let risk of riskResolution?.risks ?? [];
                  trackBy: trackRiskByCode
               "
					class="risk-item"
					[class.risk-item-disabled]="!isRiskActionable(risk)"
				>
					<p-checkbox
						[(ngModel)]="selectedRiskCodes"
						[value]="risk.riskCode"
						[disabled]="isSaving || !isRiskActionable(risk)"
						[inputId]="'risk-resolution-' + risk.riskCode"
						name="riskResolutionSelection"
					></p-checkbox>

					<div class="risk-item-content">
						<div class="risk-item-heading">
							<strong>{{ getRiskLabel(risk.riskCode) }}</strong>

							<span
								class="risk-state"
								[class.risk-state-resolved]="risk.isResolved"
							>
								{{ risk.isResolved ? 'Resolved' : 'Unresolved' }}
							</span>
						</div>

						<code>{{ risk.riskCode }}</code>

						<div
							*ngIf="
                        risk.isResolved &&
                        risk.resolution
                     "
							class="risk-audit"
						>
							<span *ngIf="risk.resolution.resolvedBy !== null">

								Resolved by
								<strong>{{ getResolvedByLabel(risk) }}</strong>
							</span>

							<span *ngIf="risk.resolution.resolvedAt">
								on
								<strong>
									{{
										risk.resolution.resolvedAt
											| DatePropertyTimezone: true : true
									}}
								</strong>
							</span>

							<p *ngIf="risk.resolution.resolutionComment">
								{{ risk.resolution.resolutionComment }}
							</p>
						</div>
					</div>
				</label>
			</div>
		</section>

		<section class="resolution-comment">
			<label for="risk-resolution-comment">
				{{ commentLabel }}
			</label>

			<textarea
				id="risk-resolution-comment"
				pInputTextarea
				rows="3"
				[(ngModel)]="commentDraft"
				[disabled]="isSaving"
				placeholder="Add context for this action..."
			></textarea>
		</section>

		<div
			*ngIf="mutationError"
			class="resolution-error"
			role="alert"
		>
			<i class="pi pi-exclamation-circle"></i>
			<span>{{ mutationError }}</span>
		</div>

		<div class="resolution-actions">
			<button
				pButton
				type="button"
				label="Close"
				class="p-button-text"
				[disabled]="isSaving"
				(click)="closeModal()"
			></button>

			<button
				pButton
				type="button"
				[label]="submitLabel"
				[icon]="
               selectedAction === 'RESOLVE'
                  ? 'pi pi-check'
                  : 'pi pi-undo'
            "
				[loading]="isSaving"
				[disabled]="!canSubmit"
				(click)="submit()"
			></button>
		</div>
	</div>
</p-dialog>
